import { render, staticRenderFns } from "./StudioEvent.vue?vue&type=template&id=5cb189d9"
import script from "./StudioEvent.vue?vue&type=script&lang=js"
export * from "./StudioEvent.vue?vue&type=script&lang=js"
import style0 from "./StudioEvent.vue?vue&type=style&index=0&id=5cb189d9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports